import { xmLocalStorage } from '@xmatters/common/utils/xmStorage';

import persistState from './creators/persistState';

export default persistState({
  key: 'allEvents',
  slicer: state => {
    const copy = { ...state.allEvents };
    delete copy.selectedEvents;
    return {
      allEvents: copy,
    };
  },
  storage: xmLocalStorage,
});
